import { ref, onMounted, onUnmounted } from 'vue'

export function useKeyboardOpen() {
  const isKeyboardOpen = ref(false)
  const isTouchDevice = window.matchMedia('(pointer: coarse)').matches
  let initialHeight = window.visualViewport?.height ?? window.innerHeight

  const KEYBOARD_THRESHOLD = 150

  function onViewportResize() {
    const currentHeight = window.visualViewport?.height ?? window.innerHeight
    // Update baseline if viewport grew (e.g. orientation change)
    if (currentHeight > initialHeight) {
      initialHeight = currentHeight
    }
    isKeyboardOpen.value = initialHeight - currentHeight > KEYBOARD_THRESHOLD
  }

  onMounted(() => {
    if (!isTouchDevice || !window.visualViewport) return
    window.visualViewport.addEventListener('resize', onViewportResize)
  })

  onUnmounted(() => {
    if (!isTouchDevice || !window.visualViewport) return
    window.visualViewport.removeEventListener('resize', onViewportResize)
  })

  return { isKeyboardOpen }
}
